import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, SaveOTSectionDataRequest } from '../../../../../../models/actor/actor';
import { AppData } from '../../../../../../models/appdata';
import { ActorService } from '../../../../../../services/actor.service';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';


@Component({
  selector: 'ngbfsedittext',
  templateUrl: './fsedittext.modal.html',
    styleUrls: ['./fsedittext.modal.scss']
})

export class NgbFsEditTextModal implements OnInit {
    @Input() TemplateName: string;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    CurrentSaveOTSectionDataRequest: SaveOTSectionDataRequest;
    public ShowList: boolean = true;
    public ApiResData: ApiResponseModel;
    CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
    PatientDetails: PatientInfoByFormattedCodeController;
    CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;
    LoadPatients() {
        this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

        //alert('Checking Forma ' + this.FormattedCode);
        this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
        this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
        this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
        this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
        this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
        this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
        this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";

        this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetPatientInfoByFormattedCodeController();
    }
    GetPatientInfoByFormattedCodeController() {
        this.StartRefreshing();


        this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
                    this.PatientDetails = this.CurrentPatientInfoByFormattedCodeController[0];
                    //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();

                    //this.LoadPatientCounsellingPlansIfAny();



                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
    constructor(public activeModal: NgbActiveModal, private actorservice: ActorService, private loaderService: SpinnerService, private tosterservice: NGXToastrService) { }
  ngOnInit() {
      this.CurrentSaveOTSectionDataRequest = new SaveOTSectionDataRequest();
      this.CurrentSaveOTSectionDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();

  }
 
 
  //onSubmit() {

  //  }
    onSubmit() {

        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveOTSectionDataRequest.ConditionalOperator = 30;
        this.CurrentSaveOTSectionDataRequest.PatientReportCode = this.PatientReportCode;
        this.CurrentSaveOTSectionDataRequest.LastUpdateTime = new Date();
        this.CurrentSaveOTSectionDataRequest.SectionData = this.sectionData;
        this.actorservice.SaveOTFormDetail(this.CurrentSaveOTSectionDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.activeModal.close();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        this.activeModal.close();


                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

    }
  ModalClose() {
    this.activeModal.close();
  }
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }
  
}
